export function generateRoomId(): string {
  return `${randomString(4)}-${randomString(4)}`;
}

export function randomString(length: number): string {
  let result = '';
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

/**
 *
 * @internal
 * used to stringify room options to detect dependency changes for react hooks.
 * Replaces processors and e2ee options with strings.
 */
export function roomOptionsStringifyReplacer(key: string, val: unknown) {
  if (key === 'processor' && val && typeof val === 'object' && 'name' in val) {
    return val.name;
  }
  if (key === 'e2ee' && val) {
    return 'e2ee-enabled';
  }
  return val;
}

export enum CustomMeetingType {
  PortugalVisa = 'PortugalVisaConsultation',
  USAVisa = 'USAVisaConsultation',
  SdrInterview = 'sdr_interview',
}

export const CUSTOM_MEETING_IDS = Object.values(CustomMeetingType);

export function isCustomMeeting(id?: string): boolean {
  return !!id && CUSTOM_MEETING_IDS.includes(id as CustomMeetingType);
}
